export default __webpack_public_path__ + "static/media/face-landmarks.c5aee368.jpg";